import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { Container } from '@/app/components/layouts/container';
import type { ProductRearBodySectionProps } from '@/app/cv/components/sections/products/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
type ProductRearBodyHeaderProps = Pick<ProductRearBodySectionProps, 'lead' | 'title' | 'description' | 'buttons'>;
interface RearBodyButtonsProps {
  buttons: ProductRearBodyHeaderProps['buttons'];
  className?: string;
}
const RearBodyButtons = t0 => {
  const $ = _c(10);
  const {
    buttons: t1,
    className
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const buttons = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn("mb-6", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "cta-buttons"
    });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== buttons) {
    t5 = buttons?.map(_temp);
    $[5] = buttons;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <ButtonGroup className={t3} {...t4}>{t5}</ButtonGroup>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export const ProductRearBodyHeader = t0 => {
  const $ = _c(21);
  const {
    lead,
    title,
    description,
    buttons: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const buttons = t2;
  const hasButtons = buttons.length > 0;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: "heading"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== lead) {
    t4 = !!lead && <h3 className="text-body-1 font-noto-bold mb-2 text-white" dangerouslySetInnerHTML={{
      __html: lead
    }} {...createDataAttributes({
      test: "lead"
    })} />;
    $[3] = lead;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== title) {
    t5 = !!title && <h2 className="font-display text-h2 whitespace-pre-line text-white" dangerouslySetInnerHTML={{
      __html: title
    }} {...createDataAttributes({
      test: "title"
    })} />;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div {...t3}>{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== buttons || $[11] !== description || $[12] !== hasButtons) {
    t7 = !!(description || hasButtons) && <div className="space-y-4" data-revealanim={true} {...createDataAttributes({
      test: "heading-wrapper"
    })}>{!!description && <p className="text-body-1 text-white" dangerouslySetInnerHTML={{
        __html: description
      }} {...createDataAttributes({
        test: "description"
      })} />}{!!hasButtons && <RearBodyButtons buttons={buttons} className="hidden lg:flex" />}</div>;
    $[10] = buttons;
    $[11] = description;
    $[12] = hasButtons;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== buttons || $[15] !== hasButtons) {
    t8 = !!hasButtons && <RearBodyButtons buttons={buttons} className="flex-col lg:hidden" />;
    $[14] = buttons;
    $[15] = hasButtons;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <Container className="grid gap-2 text-white lg:grid-cols-2 lg:gap-6" data-revealanim={true}>{t6}{t7}{t8}</Container>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
function _temp(button, index) {
  return <Button key={index} {...button}>{button.children}</Button>;
}